{
  "addAddress": "Adres toevoegen",
  "addContactData": "Contactgegevens toevoegen",
  "additionalId": "Artikelnummer",
  "additionalStockInfos": "Aanvullende voorraadinformatie",
  "additionalTax": "plus{0} BTW",
  "addProducts": "Producten toevoegen",
  "addProductToCollection": "Voeg product toe aan een verzameling",
  "addProductToComparison": "Product toevoegen aan productvergelijking",
  "addProductToQuote": "Voeg product toe aan een aanvraag",
  "address": {
    "addition": "Extra adresregel",
    "city": "Stad",
    "clientNumber": "Klantnummer",
    "companyName": "Naam en rechtsvorm",
    "country": "Land",
    "defaultBillingAddress": "Standaard factuuradres",
    "defaultDeliveryAddress": "Standaard verzendadres",
    "details": "Details",
    "email": "Email",
    "phone": "Telefoon",
    "postBox": "Postbus",
    "primaryAddress": "Primair adres",
    "street": "Straat",
    "url": "URL",
    "website": "Website",
    "zipCode": "Postcode",
    "zipCodeLong": "Postcode"
  },
  "addresses": "Adressen",
  "addToCart": "In winkelwagen",
  "archiveAll": "Alles archiveren",
  "availability": "Beschikbaarheid",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Terug naar ITscope",
  "billingAddress": "Factuuradres",
  "cancel": "Annuleren",
  "cart": {
    "optimizationFailed": "De optimalisatie van het winkelmandje is mislukt.",
    "optimizationUnavailable": "De optimalisatie van het winkelmandje kon niet worden uitgevoerd omdat er te veel artikelen in het winkelmandje zitten",
    "removeAll": "Winkelwagen leegmaken",
    "removeAllError": "Winkelwagen kon niet worden geleegd",
    "removeAllSuccess": "Winkelwagen werd succesvol geleegd"
  },
  "cartOutdated": {
    "description": "De bestelling kon niet worden verzonden omdat de winkelwagen niet meer up-to-date is. Laad de winkelwagen opnieuw en plaats de bestelling opnieuw.",
    "title": "Winkelwagentje niet meer up-to-date"
  },
  "cartPositionComment": "Opmerkingen",
  "categories": "Categorieën",
  "changed": "Gewijzigd",
  "changePassword": "Wachtwoord wijzigen",
  "charger": {
    "charger": "Oplader inbegrepen",
    "chargerIncludedTooltip": "De oplader is inbegrepen bij dit product.",
    "chargerNotIncludedHint": "Opladers met de volgende laadcompatibiliteiten kunnen met dit product worden gebruikt.",
    "chargerNotIncludedTooltip": "De oplader is niet inbegrepen bij dit product.",
    "noCharger": "Geen oplader inbegrepen"
  },
  "checkEmail": "Controleer e-mail",
  "checkoutExpiredDialog": {
    "buttonCaption": "Terug naar de kassa",
    "description": "Uw bestelling wacht",
    "title": "Ben je er nog?"
  },
  "chooseAddress": "Kies een adres",
  "clientNumber": "Klantnummer",
  "closeErrorOrders": "Kolom met foutieve bestellingen sluiten",
  "closeFilter": "Sluit het filter",
  "closeMessage": "Bericht sluiten",
  "closeQuoteActivity": "Activiteiten afsluiten",
  "collapseAccessoryCategory": "Categorie accessoires samenvouwen “{0}”",
  "collapseDescription": "Samenvouwen beschrijving “{0}”",
  "collection": {
    "addAttachment": "Bijlage toevoegen",
    "addCollection": "Nieuwe collectie",
    "addedToCartFailure": "Collectie kon niet worden toegevoegd aan het winkelmandje",
    "addedToCartPartialSuccess": "Sommige items konden niet worden toegevoegd aan het winkelmandje",
    "addedToCartSuccess": "Collectie toegevoegd aan winkelwagen",
    "addProductToExistingCollection": "Voeg product toe aan bestaande collectie:",
    "addProductToNewCollection": "of maak een nieuwe collectie aan:",
    "addToCart": "In winkelwagen",
    "assignee": "Verantwoordelijke werknemer",
    "collections": "Collecties",
    "collectProduct": "Verzamel product",
    "data": "Data",
    "deleteAction": "Collectie verwijderen",
    "deleteDialog": "Weet je zeker dat je deze collectie wilt verwijderen?",
    "deletedMessage": "De collectie werd verwijderd",
    "duplicate": "Dubbele",
    "editTitle": "Wijzig de titel van de collectie",
    "emailSent": "De collectie is met succes per e-mail verzonden.",
    "emptyCollection": "Geen producten in deze collectie",
    "lastModified": "Laatst gewijzigd",
    "noCollectionAvailable": "Geen collectie beschikbaar",
    "productAlreadyInCollection": "Product al in de collectie",
    "sendEmail": "Delen via e-mail",
    "shareCollection": "Deel collectie \"{0}\" per e-mail",
    "subject": "Onderwerp",
    "success": {
      "itemRemoved": "Product succesvol verwijderd"
    }
  },
  "common": {
    "archive": "Archief",
    "archived": "Gearchiveerd",
    "comment": "Hoe",
    "commentPlaceholder": "Voeg hier commentaar toe...",
    "comments": "Reacties",
    "dearchive": "Dearchive",
    "error": {
      "changeQuantity": "De hoeveelheid kon niet worden veranderd",
      "removeItem": "Item kon niet worden verwijderd",
      "updateAssignee": "De verantwoordelijke werknemer kon niet worden gewijzigd",
      "updateComment": "Het commentaar kon niet worden bijgewerkt",
      "updateName": "De titel van de collectie kon niet worden bijgewerkt"
    },
    "sellerComment": "Opmerking voor verkoper"
  },
  "company": {
    "deleteEmployee": "Verwijder werknemer",
    "employee": "Werknemer",
    "employeeDeleted": "Werknemer werd verwijderd",
    "employees": "Werknemers"
  },
  "companyData": "Bedrijfsgegevens",
  "companyRegistration": "Voor het opgegeven e-mailadres bestaat nog geen bedrijf. Vul het onderstaande formulier in om toegang aan te vragen.",
  "condition": {
    "B_STOCK": "B-stock",
    "BUILD_TO_ORDER": "Op bestelling bouwen",
    "BULK": "Bulk",
    "DEMONSTRATION_MODEL": "Demonstratiemodel",
    "FACTORY_REFURBISHED": "In de fabriek gereviseerd",
    "NEW": "Nieuw",
    "NEWPULL": "Reserveonderdeel van nieuw apparaat",
    "NOT_FOR_RESALE": "Niet voor wederverkoop",
    "REFURBISHED": "Gereviseerde",
    "RMA_WARE": "RMA",
    "USED": "Gebruikt",
    "USEDPULL": "Reserveonderdeel van gebruikt apparaat"
  },
  "conditionTooltip": {
    "conditionLabel": "Conditie",
    "monthsWarranty": "maanden garantie"
  },
  "contactData": {
    "contactData": "contactgegevens",
    "email": "E-mail",
    "firstName": "Voornaam",
    "lastName": "Achternaam"
  },
  "contactTitles": {
    "diverse": "Mx.",
    "female": "Mevrouw.",
    "male": "Mr.",
    "unspecified": "niet gespecificeerd"
  },
  "continue": "Ga verder",
  "copy": "Kopie",
  "coreData": "Kerngegevens",
  "costs": "Kosten",
  "create": "Maak",
  "created": "Gemaakt",
  "createdDate": "Aanmaakdatum",
  "cto": {
    "appleCtoFinder": "Apple CTO finder",
    "configure": "Configureer {0}",
    "customiseConfiguration": "Configuratie aanpassen",
    "foundProduct": "Gevonden product",
    "noProductFound": "Er kon geen product worden gevonden voor deze configuratie",
    "selectBaseModel": "Selecteer basismodel",
    "selectedConfiguration": "Gekozen configuratie",
    "selectProductClass": "Selecteer Apple productklasse"
  },
  "customerOrderId": "Bestelnummer van de klant",
  "datasheet": "Gegevensblad",
  "datasheetError": "Kon datasheet niet laden",
  "datasheetManufacturer": "Gegevensblad van de fabrikant",
  "datasheetNotFound": "Geen gegevensblad beschikbaar voor dit product",
  "datasheetPdf": "Gegevensblad (PDF)",
  "decline": "Daling",
  "declineReason": "Reden van verval",
  "delete": "Verwijder",
  "deleteAddress": "Adres wissen",
  "deleteAddressDialog": "Weet je zeker dat je dit adres wilt verwijderen?",
  "deleteContactData": "Contactgegevens verwijderen",
  "deliveryTracking": {
    "deliveryTracking": "Verzendinformatie",
    "trackPackage": "Spoorpakket"
  },
  "departments": {
    "Accounting": "Boekhouding",
    "Extern": "Extern",
    "IT": "IT",
    "Management": "Beheer",
    "Marketing": "Marketing",
    "Other": "Andere",
    "Purchasing": "Aankoop",
    "RegistrationPending": "Registratie in afwachting van",
    "Sales": "Verkoop",
    "ServiceSupport": "Service/ondersteuning"
  },
  "discount": "- {0} korting",
  "documentError": "Kan document niet laden",
  "downloadAllOrderDocumentsAsPdf": "Download alle besteldocumenten als PDF",
  "downloadOrderDocumentAsPdf": "Besteldocument “{0}” downloaden als PDF",
  "ean": "EAN",
  "editAddress": "Adres bewerken",
  "editCollectionAssignee": "Verander de verantwoordelijke werknemer",
  "editContactData": "Contactgegevens bewerken",
  "ellipsis": "...",
  "emailAddress": "E-mailadres",
  "emailForRegistration": "Voer een e -mailadres in waarmee u zich wilt registreren.",
  "emailRequestPriceHint": "De volgende mail wordt naar de winkeleigenaar gestuurd (dit is slechts een voorbeeld van de tekst):",
  "emptyCart": "Er zit geen product in de winkelwagen",
  "epeat": "EPEAT-gecertificeerd",
  "epeatTooltip": {
    "description1": "Internationaal Ecolabel voor IT-producten.",
    "description2": "Beoordeelt onder andere energie-efficiëntie, recyclebaarheid en materiaalkeuze.",
    "description3": "Niveaus: Brons, Zilver, Goud - hoe hoger, hoe milieuvriendelijker.",
    "title": "EPEAT-label"
  },
  "eprel": {
    "energyEfficiency": "Energielabel",
    "energyEfficiencyAndProductDatasheet": "Informatie over het energielabel",
    "energyEfficiencyInformationSheet": "Gegevensblad"
  },
  "error": {
    "addressCreated": "Adres kon niet worden aangemaakt",
    "addressDeleted": "Adres kon niet worden verwijderd",
    "addressesNotFound": "Adressen konden niet worden geladen",
    "addressPropertyInvalid": "Adresveld {propertyName} is ongeldig.",
    "addressSaved": "Adres kon niet worden opgeslagen",
    "alreadyInvited": "Collega {0} is al uitgenodigd",
    "alreadyRegistered": "Collega {0} is al geregistreerd",
    "cartNotFound": "Kar kon niet worden geladen",
    "categoriesNotFound": "Categorieën konden niet worden geladen",
    "changePassword": "Er ging iets mis toen ik probeerde het wachtwoord te veranderen",
    "changeQuantity": "De hoeveelheid in de winkelwagen kon niet worden gewijzigd",
    "collectionNotFound": "Collectie kon niet worden geladen",
    "documentsNotFound": "Documenten konden niet worden geladen",
    "emailAlreadyRegistered": "E-mail is al geregistreerd.",
    "emptyField": "Het veld {0} moet een geldige waarde hebben",
    "essentialShopActivationRequested": "Er is iets misgegaan bij het verzenden van het verzoek",
    "fileTooLarge": "De bestandsgrootte is te groot",
    "genericError": "Er ging iets mis",
    "identifiersNotFound": "Identifiers konden niet worden geladen",
    "invalidCharacters": "Alleen letters, cijfers en de tekens _ / . # +, evenals ronde haakjes en vierkante haakjes, zijn toegestaan (minimaal 3 tekens)",
    "invalidEmail": "Ongeldig e-mailadres",
    "invalidEmails": "De volgende mailadressen zijn nieuw geldig: {0}",
    "invalidName": "Ongeldige naam",
    "invalidNegativeNumber": "Alleen positieve getallen toegestaan",
    "invalidNumber": "Ongeldig nummer",
    "invalidUrl": "Ongeldige url",
    "invalidWhitespace": "Geen spaties aan het begin, einde of meerdere opeenvolgende spaties toegestaan",
    "invitation": "Er ging iets mis bij het verzenden van de uitnodiging",
    "keywordTooShort": "Voer een zoekterm in met ten minste 2 tekens",
    "mailBlacklisted": "Het domein {0} is niet gewhitelist. Neem contact op met uw portaalbeheerder.",
    "noAdmin": "U hebt beheerdersrechten nodig om collega's uit te nodigen",
    "noConsent": "De toestemming moet worden ondertekend",
    "oldPassword": "Ongeldig huidig wachtwoord",
    "ordersNotFound": "Orders konden niet worden geladen",
    "pageNotFound": "Pagina niet gevonden",
    "passwordNotAllowedChar": "Het wachtwoord bevat een of meer verboden tekens.",
    "passwordRepeat": "De waarden in de wachtwoordvelden komen niet overeen",
    "passwordRequirements": "Uw wachtwoord voldoet niet aan de huidige wachtwoordvereisten.",
    "positiveDigit": "De waarde moet positief zijn",
    "productAdded": "Product kon niet worden toegevoegd aan winkelwagen",
    "productAlreadyInComparison": "Het product staat al in de vergelijking",
    "productComparisonMaxNumber": "Er kunnen maximaal 3 producten worden vergeleken",
    "productDeleted": "Product kon niet worden verwijderd uit winkelwagen",
    "productNotAvailableBySupplier": "Deze leverancier biedt het product niet aan.",
    "productNotFound": "Product kon niet worden geladen",
    "productRequest": "Er ging iets mis tijdens het verzenden van het verzoek",
    "productTypeIncorrectForComparison": "Alleen producten in dezelfde categorie kunnen met elkaar worden vergeleken",
    "quoteForbidden": "Deze offerte is nog niet actief",
    "quoteNotFound": "Kan geen offerte laden",
    "quotesNotFound": "Kan offertes niet laden",
    "refresh": "Andere gebruikers hebben wijzigingen aangebracht. Vernieuw de pagina.",
    "registration": "Er ging iets mis bij het verzenden van de registratie",
    "registrationTokenError": "De link om een nieuwe gebruiker te registreren lijkt niet te werken. Vraag een nieuwe aan.",
    "requiredField": "Verplicht veld",
    "resetPassword": "Er ging iets mis toen ik probeerde het wachtwoord te resetten",
    "resetTokenError": "De link om het wachtwoord opnieuw in te stellen is niet meer geldig. Vraag een nieuwe aan.",
    "serverError": "Serverfout",
    "shortPassword": "Moet minstens 8 tekens lang zijn",
    "startPage": "Startpagina kon niet worden geladen",
    "timeout": "Het verzoek is verlopen",
    "tooManyRequests": "Te veel vragen. Probeer het later opnieuw.",
    "unknownError": "Er is een onbekende fout opgetreden tijdens het verzoek.",
    "unknownLoginError": "Er is een onbekende fout opgetreden bij het inloggen.",
    "unsupportedMediaType": "Het bestandstype wordt niet ondersteund",
    "updateComment": "Het commentaar in vrije tekst kon niet worden bijgewerkt",
    "userDeactivated": "De opgegeven gebruiker is gedeactiveerd, inloggen is momenteel niet mogelijk.",
    "validDigit": "De waarde moet een geldig geheel getal zijn",
    "wrongCredentials": "Uw e-mailadres of wachtwoord is onjuist."
  },
  "errorId": "Fout-ID",
  "errorPageHeadline": "Er ging iets mis.",
  "errorPageOops": "Ooops",
  "errorPageQuoteNotAvailableSorry": "Probeer het later nog eens.",
  "errorPageStart": "Ga naar de startpagina",
  "essentialShopDeactivated": {
    "descriptionEnd": "Neem contact op met uw partner om toegang te krijgen.",
    "descriptionPoint1": "De geschiedenis van uw aanbiedingen te bekijken",
    "descriptionPoint2": "direct offertes aan te vragen bij uw partner",
    "descriptionPoint3": "toegang te krijgen tot een assortiment van 50.000 IT-producten met filter en zoekfunctie",
    "descriptionPoint4": "eenvoudig en direct te bestellen",
    "descriptionStart": "In de Essential-Shop heeft u de mogelijkheid om:",
    "descriptionTitle": "De Essential-Shop van uw partner is momenteel gedeactiveerd.",
    "pageTitle": "Essential-Shop gedeactiveerd",
    "requestActivation": "Activering aanvragen",
    "requestActivationHint": "Geef uw e-mailadres op, zodat uw partner contact met u kan opnemen."
  },
  "excludingVatHint": "Alle prijzen excl.{0} BTW",
  "excludingVatShort": "excl.{0} BTW",
  "expandAccessoryCategory": "Accessoires categorie “{0}” uitbreiden",
  "expandDescription": "Beschrijving uitbreiden “{0}”",
  "featureAd": {
    "comparison": {
      "description": "U kunt producten ter vergelijking toevoegen via de productpagina",
      "shortDescription": "Je kunt nu producten vergelijken.",
      "title": "Productvergelijking"
    },
    "descriptionEnd": "Wij worden geïnformeerd en presenteren u een direct bestelbare offerte hier in uw portaal.",
    "descriptionStart": "Zo vraagt u een verzameling producten aan:",
    "NEW": "NIEUW",
    "requestFunction": "Offertes aanvragen",
    "step1": "Klik op \"Aanvraag aanmaken\"",
    "step2": "Producten toevoegen",
    "step3": "Verstuur het verzoek",
    "tryItOut": "Probeer het eens!"
  },
  "filter": {
    "filter": "Filter",
    "filters": "Filters",
    "noFiltersSelected": "Geen filters geselecteerd",
    "productFilters": "Kenmerken",
    "productType": "Soort product",
    "resetFilter": "Filter resetten"
  },
  "finishRegistration": "Registratie voltooien",
  "forgotPassword": "Wachtwoord vergeten?",
  "grading": {
    "A": "Als nieuw",
    "B": "Zeer goed",
    "C": "Goed",
    "D": "Acceptabel"
  },
  "hideCategories": "Categorieën verbergen",
  "hideCategory": "Vouw de categorie",
  "hidePassword": "Verberg het wachtwoord",
  "impersonateMode": "Klantbeeld - U bent ingelogd als B2B shop admin in {0}",
  "impersonateModeEssentialShop": "Klantweergave – Aangemeld als winkeleigenaar",
  "includingVat": "incl.{0} BTW",
  "includingVatHint": "Alle prijzen zijn inclusief{0} BTW",
  "includingVatShort": "incl.{0} BTW",
  "invitationHint": "Hier kunt u andere collega's uitnodigen voor uw portaal. Voer de e-mailadressen in waaraan u een uitnodiging wilt sturen en scheid ze met een puntkomma of spatie.",
  "inviteColleagues": "Collega's uitnodigen",
  "languages": {
    "de": "Duits",
    "en": "Engels",
    "es": "Spaans",
    "fr": "Frans",
    "it": "Italiaans",
    "nl": "Nederlands",
    "pl": "Pools"
  },
  "legalInfo": "Juridische informatie",
  "less": "minder",
  "localization": "Lokalisatie",
  "login": "Inloggen",
  "login_sso": "Inloggen met eenmalige aanmelding (SSO)",
  "loginQuotesPortal": "Inloggen offertes portaal",
  "manufacturerId": "Fabrikant ID",
  "max": "Max.",
  "maxLength": "Maximale tekenlengte van {0} bereikt",
  "mobex360Info": "Als het mobex360-krediet onvoldoende is, wordt de bestelling automatisch gefactureerd!",
  "mobexPaymentMethod": {
    "CREDIT": "Met mobex360 krediet",
    "INVOICE": "Per factuur"
  },
  "more": "meer",
  "moreInfoEpeatTooltip": "Meer informatie over het EPEAT-label",
  "moreUppercase": "Meer",
  "myCompany": "Mijn bedrijf",
  "myProfile": "Mijn profiel",
  "name": "Naam",
  "newPassword": "Nieuw wachtwoord",
  "newPasswordRepeat": "Nieuw wachtwoord bevestigen",
  "no": "Geen",
  "noAppleProductsAvailable": "Geen Apple producten beschikbaar",
  "noCategoriesFound": "Geen categorieën beschikbaar",
  "noCollectionsFound": "Geen collecties beschikbaar",
  "noDataAvailable": "Er zijn geen gegevens beschikbaar",
  "noEntries": "Geen inzendingen beschikbaar",
  "noImageAvailable": "Geen foto beschikbaar",
  "noItemsInQuote": "Deze offerte bevat geen posities",
  "noOrderDocumentsFound": "Geen documenten beschikbaar",
  "noOrdersFound": "Geen bestellingen beschikbaar",
  "noProductsFound": "Geen producten gevonden",
  "noSupplier": "Niet toegewezen",
  "nullPriceLabel": "-.--",
  "oldPassword": "Huidig wachtwoord",
  "onlyWholePositiveNumbers": "Alleen positieve gehele getallen toegestaan",
  "open": "Open",
  "openCart": "Open het winkelwagentje",
  "openCategory": "Vouw de categorie uit",
  "openFilter": "Open het filter",
  "openMenu": "Open het menu",
  "openProductComparison": "Open de productvergelijking",
  "openProductPage": "Productpagina openen",
  "openTopiCheckout": "topi-kassa openen",
  "optimizationStrategyType": {
    "MANUAL": "Handmatig",
    "MINPRICE": "Beste prijs",
    "MINSUPPLIERS": "Minimale bronnen"
  },
  "order": {
    "addedToCartFailure": "Bestelling kon niet worden toegevoegd aan het winkelmandje",
    "addedToCartPartialSuccess": "Sommige items konden niet worden toegevoegd aan het winkelmandje",
    "addedToCartSuccess": "Bestelling toegevoegd aan winkelwagen",
    "customerOrderIdMissing": "Er moet een klantorder-id worden opgegeven.",
    "declineOrder": "Opdracht weigeren",
    "deleteDialog": "Weet u zeker dat u deze bestelling wilt verwijderen?",
    "deleteLastItemDialog": "Opgelet: Bij het verwijderen van het laatste bestelitem wordt ook de volledige bestelling verwijderd. Wilt u doorgaan?",
    "deleteOrder": "Bestelling verwijderen",
    "deleteOrderItem": "Orderpositie verwijderen",
    "details": "Bestel",
    "documents": "Documenten",
    "editAddressHint": "Adreswijzigingen hebben alleen gevolgen voor deze bestelling.",
    "exclTotalTax": "excl.{0} VAT {1}",
    "goToOrder": "Verdergaan met bestellen",
    "inclTotalTax": "incl.{0} VAT {1}",
    "inEuTotalTax": "plus{0} VAT {1}",
    "moreInfosLabel": "Verdere details",
    "netDiscount": "Extra korting",
    "noApprover": "Er lijkt geen goedkeurder in aanmerking te komen voor deze bestelling. Neem contact op met de beheerder van uw portaal.",
    "noOrderRightHint": "Je hebt geen toestemming om de order uit te voeren.",
    "order": "Bestel",
    "orderAlreadyBeingProcessed": "Bestelling wordt al verwerkt. Wacht a.u.b. een paar minuten.",
    "orderDate": "Order date",
    "orderLimitApprovalHint": "De volgende personen worden per e-mail op de hoogte gebracht van uw aanvraag tot goedkeuring van de bestelling. Zodra de ordergoedkeuring is bevestigd of afgewezen, wordt u per e-mail geïnformeerd.",
    "orderLimitHint": "De order ter waarde van {0} heeft uw huidige orderlimiet van {1} overschreden. Gelieve een ordergoedkeuring aan te vragen.",
    "orderNotFound": "Bestelling kon niet worden geladen",
    "orderNumber": "Bestelnummer",
    "orderNumberDuplicate": "Het bestelnummer {0} is al gebruikt voor een bestelling. Probeer een ander bestelnummer.",
    "orderNumberGeneratedAfterOrder": "Wordt gegenereerd na de bestelling",
    "orderNumberMissing": "Er moet een bestelnummer worden opgegeven.",
    "orderNumbers": "Bestelnummers",
    "orderRequested": "Verzoek verzonden",
    "orders": "Bestellingen",
    "orderSent": "Uw bestelling is ingediend en wordt nu verwerkt.",
    "orderTimeoutError": "Geen bestelrespons ontvangen. Laad de pagina opnieuw.",
    "partialShipmentAllowed": "Gedeeltelijke verzending toegestaan",
    "paymentMethodMissing": "Er moet een factureringsmethode worden opgegeven.",
    "quantitySurcharge": "Minimum ordertoeslag",
    "requestOrder": "Verzoek",
    "selectAddressHint": "Alleen door u aangemaakte adressen kunnen worden gebruikt.",
    "sendOrder": "Bestellen tegen betaling",
    "shippingAddress": "Verzendadres",
    "shippingCosts": "Verzending",
    "shippingCostsGross": "Verzendkosten bruto",
    "shippingCostsNet": "Verzendkosten netto",
    "subTotal": "Subtotaal",
    "toOrder": "Bestelling plaatsen",
    "toOrderFrom": "Bestel van {0}",
    "totalCostsGross": "Totaalbedrag bruto",
    "totalCostsNet": "Totaalbedrag netto"
  },
  "orderApproval": {
    "approvableOrders": "Goedgekeurde bestellingen",
    "approvedInformation": "Orde goedgekeurd door {0} op {1}.",
    "declinedInformation": "Bestelling geweigerd door {0} op {1}.",
    "orderDeclined": "Bestelling succesvol geweigerd",
    "pendingInformation": "Op {1} is voor deze order op {0} goedkeuring gevraagd van de volgende personen:",
    "pendingInformationApprover": "Er is een ordergoedkeuring naar u verzonden voor deze order op {0}.",
    "pendingInformationRequester": "Je hebt een order goedkeuring ingediend bij de volgende persoon op {0}:"
  },
  "orderBy": "Bestelling geplaatst bij {0}",
  "ordered": "Besteld",
  "orderLimits": {
    "activateOrderLimits": "Activeer orderlimieten",
    "default": "Standaard",
    "defaultApprovers": "Standaard goedkeurder",
    "defaultApproversEmpty": "Geen standaard goedkeurder geselecteerd",
    "defaultApproversUsed": "Standaard goedkeurders worden gebruikt",
    "defaultLimit": "Algemene limiet",
    "defaultLimitDescription": "Deze orderlimiet is de standaardwaarde voor alle werknemers en wordt overschreven door specifieke orderlimieten voor werknemers.",
    "description": "Door limieten toe te kennen, kunnen medewerkers slechts tot een bepaalde waarde bestellen. Bestellingen die deze waarde overschrijden, moeten worden aangevraagd bij een collega met goedkeuringsrechten.",
    "editOrderLimitUser": "Orderlimiet van gebruiker “{0}” wijzigen",
    "editStandardApprovers": "Standaard goedkeurders bewerken",
    "individual": "Individueel",
    "noEmployeeFound": "Geen werknemer gevonden",
    "noEmployeesFound": "Er zijn geen medewerkers beschikbaar",
    "orderApproval": "Goedkeuring van de bestelling",
    "orderApprover": "Goedkeurder van bestellingen",
    "orderLimit": "Orderlimiet",
    "orderRight": "Bestel rechts",
    "unlimited": "Onbeperkt"
  },
  "orderOutdated": {
    "description": "De bestelling kon niet worden verzonden omdat deze verouderd is. Laad de bestelling opnieuw en voer deze opnieuw uit.",
    "title": "Bestelling niet meer actueel"
  },
  "orderStatus": {
    "ADVISED": "Verzonden",
    "ARRIVED": "Bestelling ontvangen",
    "ARRIVED_WARNING": "Ontvangen met waarschuwing",
    "BLOCKED": "Geblokkeerd",
    "BLOCKED_BYLIMIT": "Geblokkeerd",
    "CANCELED": "Geannuleerd",
    "ERROR": "Fout",
    "IN_TOPI_CHECKOUT": "In de topi-kassa",
    "INVOICED": "Gefactureerd",
    "ORDERED_ELSEWHERE": "Elders besteld",
    "PARTIALLY_ADVISED": "Gedeeltelijk verzonden",
    "PARTIALLY_INVOICED": "Gedeeltelijk gefactureerd",
    "PARTIALLY_PROCESSING": "Gedeeltelijk bevestigd",
    "PAYMENT_AWAITING": "In afwachting van betaling",
    "PAYMENT_SUCCESSFUL": "Betaling succesvol",
    "PENDING_TOPI_APPROVAL": "In afwachting van autorisatie",
    "PORTAL_APPROVAL_DENIED": "Afgewezen",
    "PREPARING": "In afwachting van",
    "PROCESSING": "Bestelling bevestigd",
    "REJECTED": "Afgewezen",
    "SENDING_ERROR": "Overdrachtsfout",
    "SENT": "Verzonden",
    "TOPI_DECLINED": "Afgewezen door topi",
    "TOPI_EXPIRED": "topi aanbieding verlopen",
    "TRANSMITTING": "Het verzenden van"
  },
  "partsList": "Onderdelenlijst",
  "password": "Wachtwoord",
  "passwordRepeat": "Herhaal wachtwoord",
  "paymentMethod": "Betaalmethode",
  "PDF": "PDF",
  "per": "per",
  "personalData": "Persoonlijke gegevens",
  "pleaseSelect": "Selecteer alstublieft...",
  "portal": "Portaal",
  "portalPaused": "Portaal gepauzeerd",
  "portalPausedDescription": "Dit portaal is momenteel gepauzeerd, daarom is inloggen niet mogelijk. Als u vragen heeft, neem dan contact op met uw portaalhouder.",
  "positions": "Geen positie | {n} positie | {n} posities",
  "price": {
    "graduatedPrices": "Gegradueerde prijzen",
    "manufacturerSuggestedRetailPrice": "MSRP",
    "packaging": "Verpakkingseenheid",
    "packaging_contentUnit": "Inhoud eenheid:",
    "packaging_contentUnit_label": "Eenheid van het artikel binnen een besteleenheid (bv. \"stuk\" in besteleenheid \"pak\").",
    "packaging_intervalQuantity": "Hoeveelheid interval:",
    "packaging_intervalQuantity_label": "Hoeveelheid die het interval aangeeft waarin het artikel kan worden besteld (in besteleenheden).",
    "packaging_minQuantity": "Minimum bestelhoeveelheid:",
    "packaging_minQuantity_label": "De laagste hoeveelheid voorraad die besteld moet worden.",
    "packaging_numberContentUnitPerOrderUnit": " Verpakkingshoeveelheid:",
    "packaging_numberContentUnitPerOrderUnit_label": "Het aantal subeenheden in de eenheid van het artikel.",
    "packaging_orderUnit": "Besteleenheid:",
    "packaging_orderUnit_label": "Eenheid waarin het product kan worden besteld; alleen veelvouden van de artikel-eenheid kunnen worden besteld.",
    "packaging_priceQuantity": "Prijs hoeveelheid:",
    "packaging_priceQuantity_label": "Een veelvoud van de besteleenheid, dat de hoeveelheid aangeeft waarop de prijzen betrekking hebben.",
    "packaging_supplierPackingQuantity": "Leverancier verpakking hoeveelheid:",
    "packaging_supplierPackingQuantity_label": " Verpakkingshoeveelheid van de leverancier (in besteleenheden).",
    "price": "Prijs",
    "priceBillingPeriod": "per {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "O/R",
    "pricePurchase": "WSP",
    "priceSubscriptionPeriod": "{0} contractperiode",
    "priceVatStar": "*",
    "startingAt": "beginnend bij {0}"
  },
  "priceRange": {
    "applyPriceRange": "Prijsklasse toepassen",
    "fromPriceRange": "Van {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Ongeldige prijsklasse",
    "priceRange": "Prijsklasse",
    "priceRangeFrom": "Prijsklasse",
    "priceRangeTo": "Prijsklasse omhoog",
    "toPriceRange": "Tot {0} {1}"
  },
  "print": "Afdrukken",
  "privacy": "Privacy",
  "privacyConsent": "Ik ga ermee akkoord dat mijn gegevens worden verwerkt in overeenstemming met het privacybeleid.",
  "product": "Product",
  "productAccessories": "Accessoires",
  "productComparison": {
    "highlightDifferences": "Benadruk verschillen",
    "noData": "Er zijn geen vergelijkbare gegevens gevonden voor de geselecteerde producten",
    "noMobileVersion": "De productvergelijking is niet beschikbaar in de mobiele weergave",
    "noProducts": "Geen producten in vergelijking",
    "pageTitle": "Producten vergelijken",
    "removeProduct": "Verwijder product uit vergelijking"
  },
  "productDescription": "Beschrijving",
  "productId": "Product ID",
  "productIdentifiers": "Product ID's",
  "productNoLongerAvailable": "Product niet langer beschikbaar",
  "products": "Producten",
  "productSort": {
    "AVAILABILITY": "Beschikbaarheid",
    "CALC_PRICE_ASC": "Prijs oplopend",
    "CALC_PRICE_DESC": "Prijs dalend",
    "NAME_ASC": "Productnaam oplopend",
    "NAME_DESC": "Productnaam aflopend",
    "POPULARITY": "Populariteit",
    "RELEVANCE": "Relevantie",
    "STOCK": "Voorraadniveau"
  },
  "productStockInfo": {
    "nextDelivery": "Volgende leveringsdatum volgens distributeur verwacht op {0}.",
    "nextDeliveryB2B": "Verwachte leveringsdatum aan de leverancier: {0}.",
    "noNextDelivery": "De precieze leveringsdatum is onbekend.",
    "onStock": "{0} op voorraad",
    "onSupply": "{0} Binnenkort beschikbaar",
    "unavailableMessage": "Dit product is niet beschikbaar."
  },
  "punchout": {
    "backToProcurement": "Terug naar uw systeem",
    "backToProcurementCaption": "Zonder order terug naar uw systeem | Neem een positie in uw systeem | {n} posities terug naar uw systeem",
    "table": {
      "position": "ID",
      "price": "Prijs",
      "quantity": "Qty",
      "sum": "Som",
      "title": "Titel"
    }
  },
  "quantityFrom": "Hoeveelheid van",
  "quoteOutdated": {
    "description": "De bestelling kon niet worden verzonden omdat de offerte niet meer actueel is. Laad de offerte opnieuw en plaats de bestelling opnieuw.",
    "title": "Offerte niet meer actueel"
  },
  "quotePreview": "Je bent in de offerte preview",
  "quoteRegistration": {
    "description": "Door u te registreren in uw persoonlijke Essential Shop ontvangt u ...",
    "products": "Toegang tot <b>50.000 IT-producten</b>",
    "quoteDocument": "toegang tot alle relevante <b>offerte documenten</b>",
    "quoteHistory": "de <b>offertegeschiedenis</b> met alle eerder ontvangen offertes",
    "quoteRequest": "de mogelijkheid om <b>aanvragen</b> in te dienen"
  },
  "quoteRequest": {
    "cannotEditRequest": "Wijzigingen zijn niet meer mogelijk, het verzoek is al verzonden.",
    "emptyRequest": "Nog geen producten toegevoegd",
    "lineItemAdded": "Item is succesvol toegevoegd",
    "notInAssortment": "Momenteel niet in het assortiment",
    "requestAgain": "Opnieuw verzoek",
    "requestNotFound": "Offerteaanvraag kon niet worden gevonden",
    "sendRequest": "Stuur verzoek",
    "sentQuoteRequest": "Offerteaanvraag is verzonden",
    "textLineItemAdd": "Tekst toevoegen",
    "textLineItemChangeError": "Titel tekstpositie kon niet worden gewijzigd"
  },
  "quotes": {
    "acceptQuote": "Offerte accepteren",
    "addProductToExistingQuote": "Product toevoegen aan bestaande aanvraag:",
    "addProductToNewQuote": "of nieuwe aanvraag maken:",
    "author": "Auteur",
    "createRequest": "Aanvraag aanmaken",
    "declineInformation": "Offerte is geweigerd door {0} op {1}.",
    "declineQuote": "Offerte weigeren",
    "declineQuoteDialog": "Weet je zeker dat je deze offerte wilt weigeren?",
    "deleteDescription": "Weet u zeker dat u wilt dat dit verzoek wordt verwijderd?",
    "deleteTitle": "Verzoek verwijderen",
    "deselectOptionalItem": "Deselecteer optionele positie",
    "duplicateUserWarning": "Je kunt deze aanbieding niet accepteren omdat je e-mailadres al aan een ander bedrijf is gekoppeld. Neem contact op met de maker van de aanbieding.",
    "editTitle": "Wijzig de titel van het verzoek",
    "new": "Nieuw",
    "noLongerValid": "Deze aanbieding is verlopen op \"{0}\" en is niet langer geldig.",
    "noOptionalPosition": "Geen optionele positie",
    "noQuoteEmptySpace": "Nog geen offerte beschikbaar",
    "noQuoteRequestsFound": "Geen verzoeken beschikbaar",
    "noQuotesFound": "Geen offertes beschikbaar",
    "quote": "Offerte",
    "quoteRequested": "Verzoek is succesvol aangemaakt",
    "quotes": "Offertes",
    "request": "Verzoek",
    "selectOptionalItem": "Selecteer optionele positie",
    "showActivity": "Activiteiten tonen"
  },
  "quoteStatus": {
    "ACCEPTED": "Aanvaard",
    "DRAFT": "Ontwerp",
    "NEGOTIATION": "In uitvoering",
    "REJECTED": "Afgewezen",
    "REQUESTED": "Aangevraagd"
  },
  "readOnlyMode": "U bevindt zich momenteel in de modus alleen-lezen.",
  "realtimePrices": "Realtime prijzen",
  "realtimePricesLoaded": "Real-time prijzen geladen",
  "recipients": "Ontvangers",
  "refresh": "Vernieuwen",
  "refreshPage": "Pagina herladen",
  "register": "Registreer",
  "registerCompany": "Registreer bedrijf",
  "registration": "Registratie",
  "registrationDisabled": "Registratie gedeactiveerd",
  "registrationDisabledDescription": "De exploitant heeft de registratie en het inloggen op dit portaal gedeactiveerd.",
  "registrationLinkSent": "Er is een e-mail met de registratielink naar je e-mailadres verzonden. Open de link om de registratie te voltooien.",
  "registrationRequested": "Het verzoek is doorgegeven aan de portaaloperator. U ontvangt een bericht zodra het verzoek is aanvaard.",
  "removeDialog": "Weet je zeker dat je deze werknemer wilt verwijderen?",
  "removeProductFromCart": "Verwijder het product uit de winkelwagen",
  "removeProductFromCollection": "Verwijder het product uit het verzamelen",
  "removeProductFromQuoteRequest": "Verwijder het product van het verzoek",
  "requestPrice": "Prijs aanvragen",
  "requestRegistration": "Toegang aanvragen",
  "resetPassword": "Wachtwoord opnieuw instellen",
  "rma": {
    "requested": "Retouraanvraag verzonden",
    "return": "Retourzending",
    "returned": "geretourneerd",
    "returnReason": "Reden voor terugkeer",
    "selectedPositions": "Geselecteerde posities",
    "selectPositions": "Selecteer de artikelen voor uw retourzending",
    "selectProductForReturn": "Selecteer product voor retourzending",
    "selectReturnReason": "Selecteer reden"
  },
  "save": "Sla",
  "saveAddress": "Adres opslaan",
  "search": "Zoek op",
  "searchAll": "Zoek alle",
  "searchResults": "Zoek naar \"{0}\" in producten",
  "send": "Stuur",
  "sendInvitation": "Stuur uitnodiging",
  "serialNumbers": {
    "copyAll": "Kopieer alles",
    "serialNumbers": "Serienummers",
    "serialNumbersCopied": "Serienummers gekopieerd naar het klembord"
  },
  "serverOffline": {
    "description": "Het portaal is momenteel niet beschikbaar wegens onderhoud. Probeer het later nog eens.",
    "title": "Portaal niet beschikbaar"
  },
  "shippingCostsShort": "Verzending",
  "shoppingCart": "Winkelwagen",
  "shortUrl": {
    "enterZipCode": "Voer de postcode van je adres in om de aanbieding te openen:",
    "enterZipCodeTitle": "Postcode invoeren",
    "error": "Oeps! Deze link is niet geldig!",
    "wrongZipCode": "De ingevoerde postcode is ongeldig!"
  },
  "showCategories": "Categorieën tonen",
  "showErrorOrders": "Toon alle bestellingen met een foutstatus",
  "showPassword": "Toon wachtwoord",
  "signIn": "Inloggen",
  "signOut": "Afmelden",
  "sortBy": "Sorteren op",
  "sortbyAsc": "Sorteren in oplopende volgorde op “{0}”.",
  "sortByDesc": "Aflopend sorteren op “{0}”.",
  "sources": "Voorzieningsbronnen",
  "status": "Status",
  "stock": "Voorraad",
  "stockStatus": {
    "Available": "Beschikbaar",
    "NotAvailable": "Niet beschikbaar",
    "OnOrder": "Op bestelling",
    "OnStock": "Op voorraad",
    "Ordered": "Binnenkort beschikbaar",
    "Unknown": "Onbekend",
    "Warehouse": "externe voorraad"
  },
  "stockStatusDescription": "Voorraadstatus is “{0}”.",
  "subsidiaryMode": "Klantbeeld - U bent ingelogd op {0}",
  "success": {
    "addedToCollection": "Product succesvol toegevoegd aan collectie",
    "addedToCollectionLink": "Product succesvol toegevoegd aan collectie \"{0}\" >>",
    "addedToComparison": "Product toegevoegd ter vergelijking",
    "addedToQuote": "Product is toegevoegd aan de zoekopdracht.",
    "addedToQuoteLink": "Het product is toegevoegd aan de offerteaanvraag. >>",
    "addressCreated": "Adres werd aangemaakt",
    "addressDeleted": "Adres werd verwijderd",
    "addressSaved": "Adres werd opgeslagen",
    "cartRefreshed": "Winkelmandje bijgewerkt",
    "changeLanguage": "Taal veranderd",
    "changePassword": "Wachtwoord succesvol gewijzigd",
    "essentialShopActivationRequested": "Activeringsverzoek is verzonden",
    "invitationSent": "Uitnodiging succesvol verzonden",
    "orderArchived": "Bestelling gearchiveerd",
    "orderDearchived": "Bestel dearchived",
    "productAdded": "Product is toegevoegd aan de winkelwagen",
    "productDeleted": "Product is verwijderd uit de winkelwagen",
    "productRequested": "Verzoek om product verzonden",
    "quoteArchived": "Offerte gearchiveerd",
    "quoteDearchived": "Offerte niet gearchiveerd",
    "registrationComplete": "Registratie succesvol",
    "removedFromComparison": "Product is verwijderd uit de vergelijking",
    "resetPassword": "Er is een e-mail gestuurd naar \"{0}\" als er een actieve gebruikersaccount bestaat."
  },
  "supplier": "Leverancier",
  "supplierPid": " Distributeur nr.",
  "switchSubsidiary": "Verander van bedrijf",
  "switchSubsidiaryHint": "U kunt inloggen bij andere bedrijven",
  "technicalData": "Technische gegevens",
  "terms": "GTC",
  "time": {
    "day": "dag",
    "hour": "uur",
    "minute": "minuut",
    "month": "maand",
    "year": "jaar"
  },
  "title": "Titel",
  "to": "naar",
  "today": "Vandaag",
  "topiExpiredHint": "De aanbieding bij topi is helaas verlopen. Voeg de producten opnieuw toe aan je winkelmandje via het menu met de drie puntjes en klik vervolgens op 'Verder naar de huurconfiguratie'.",
  "transactionType": {
    "DELIVERY": "Leveringsbon",
    "INVOICE": "Proforma factuur",
    "ORDER": "Bestel",
    "ORDERSTATUS": "Antwoord op de bestelling",
    "PAYMENT": "Betaling"
  },
  "unknown": "onbekend",
  "updated": "Bijgewerkt",
  "user": {
    "avatar": "Avatar",
    "company": "Bedrijf",
    "contactTitle": "Titel contactpersoon",
    "department": "Afdeling",
    "email": "E-mail",
    "firstName": "Voornaam",
    "language": "Taal",
    "lastName": "Achternaam",
    "permissions": {
      "changeSubsidiary": "Overstappende bedrijven",
      "changeSubsidiaryDescription": "Bepaalt of de gebruiker mag inloggen bij verwante bedrijven.",
      "permissions": "Gebruikersrechten",
      "shopAdmin": "Admin",
      "shopAdminDescription": "Als admin kan de gebruiker de rechten, contactgegevens, orderlimieten en goedkeuringen van andere medewerkers bewerken. Daarnaast kan de admin-gebruiker nieuwe collega's direct uitnodigen voor het portaal.",
      "submitOrder": "Bestellingen plaatsen",
      "submitOrderDescription": "Bepaal of de gebruiker orders mag plaatsen."
    },
    "phone": "Telefoonnummer",
    "phoneMobile": "Mobiel telefoonnummer",
    "settings": {
      "allowTracking": "Verbeter de gebruikerservaring",
      "allowTrackingDescription": "Neem deel aan het optimalisatieprogramma voor een betere gebruikerservaring.",
      "settings": "Gebruikersinstellingen"
    }
  },
  "validDate": "Geldig tot",
  "viewToggle": {
    "ordersApprovals": "Schakel het besteloverzicht over naar \"Goedgekeurde bestellingen\"",
    "ordersGrid": "Schakel het besteloverzicht over naar de kolomweergave",
    "ordersList": "Schakel het besteloverzicht om de weergave weer te geven",
    "productsCards": "Schakel het productoverzicht over naar de betegelde weergave",
    "productsList": "Schakel het productoverzicht om de weergave weer te geven",
    "quoteActivityChat": "Schakel de activiteit van de activiteit om te chatten",
    "quoteActivityHistory": "Schakelactiviteiten Bekijk naar de geschiedenis"
  },
  "windowTitle": {
    "Collection": "Collectie",
    "CompanyOrderLimit": "Goedkeuring van de bestelling",
    "Login": "Inloggen",
    "Registration": "Registratie pagina",
    "StartPage": "Startpagina"
  },
  "writeSomething": "Schrijf iets...",
  "yes": "Ja",
  "yesterday": "Gisteren"
}
